// extracted by mini-css-extract-plugin
export default {"cadreBanner":"Banner_cadreBanner__fP0i8","imgBanner":"Banner_imgBanner__wUbuj","imgTexte":"Banner_imgTexte__S27m0","ssCadreBanner":"Banner_ssCadreBanner__RmaJU"};